import React from 'react';
import CompanyInfoPage from 'components/templates/CompanyInfoPage/CompanyInfoPage';
import { useRouter } from 'next/router';
import {
  enTermsConditions,
  frTermsConditions,
  deTermsConditions,
} from './TranslatedTermsAndConditions';

export interface Props {
  className?: string;
}

// NOTE / TODO: This has been translated without the use of the
// useTranslate hook because there is a vast quantity of
// translations needed. The plan is to translate this properly
// using Locize

const TermsAndConditions: React.FC<Props> = ({ className }) => {
  const { locale } = useRouter();

  let translatedTCs;
  if (locale === 'fr-fr') translatedTCs = frTermsConditions;
  else if (locale === 'de-de') translatedTCs = deTermsConditions;
  else translatedTCs = enTermsConditions;

  return (
    <CompanyInfoPage>
      <main>
        <article className={className}>{translatedTCs}</article>
      </main>
    </CompanyInfoPage>
  );
};
export default TermsAndConditions;
